import useTranslation from 'next-translate/useTranslation'

import { HeadingProps } from '@/views/creator/ts'

function Heading({ nickname, category }: HeadingProps) {
  const { t } = useTranslation('global')

  return (
    <div
      className="self-center 2md:space-y-2 2md:self-start"
      style={{ gridArea: 'heading' }}
    >
      <h1 className="text-xl font-medium">{nickname}</h1>
      {category && (
        <div className="flex mt-1 space-x-2 text-sm">
          <span>{t('category')}:</span>
          <span className="text-black/60">{category}</span>
        </div>
      )}
    </div>
  )
}

export default Heading
